<template>
  <common-dialog
    ref="dialog"
    :title="title"
    width="1100px"
    :in-dialog="inDialog"
  >
    <list
      ref="list"
      common
      :show-checkbox="multiple"
      :is_listDialog="true"
      :is-show="true"
      :modelType="modelType"
      :isPage="isPage"
      :isFunc="isFunc"
      :isSelect="true"
    >
      <template #column>
        <slot name="column" />
        <template v-if="selectable && !multiple">
          <el-table-column label="操作" align="center" width="60" fixed="right">
            <template slot-scope="{ row }">
              <el-button
                :disabled="row.DistrictId == NoId"
                @click="onSelect(row)"
                type="text"
                >选择</el-button
              >
            </template>
          </el-table-column>
        </template>
      </template>
    </list>
    <template slot="footer">
      <slot name="footer">
        <el-button
          type="primary"
          @click="selectMultiple"
          v-if="isShow && selectable && multiple"
          >选择</el-button
        >
      </slot>
    </template>
  </common-dialog>  
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";

export default {
  components: { commonDialog, list },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "进货单列表",
    },
    modelType: {
      type: String,
      default: "businesspurchaseinquiry",
    },
    isShow: {
      type: Boolean,
      default: true,
    },
    isPage: {
      type: Boolean,
      default: false,
    },
    isFunc: {
      type: Boolean,
      default: true,
    },
    ordertype:{
      type:String,
      default:""
    }
  },
  data() {
    return {
      params: {},
      NoId: 0,
    };
  },
  methods: {
    getData(params = {}) {
      console.log("ordertype",this.ordertype);
      this.$refs.list.ordertype=this.ordertype;
      this.$refs.list.clearList()
      this.params = { ...params };
      this.$refs.list.getData(this.params);

      
    },
    setBypeId(BusinessTypeId){
      this.$refs.list.params.BusinessTypeId = BusinessTypeId
    },
    selectMultiple() {
      console.log("this.$refs.list",this.$refs.list);
      let data = {
        Order: this.$refs.list.orderNo,
        TradeUnitId: this.$refs.list.TradeUnitId,
        TradeUnitName: this.$refs.list.TradeUnitName,
        List: this.$refs.list.subSelectList,
        InvoiceTypeId:this.$refs.list.InvoiceTypeId,
        InvoiceTypeName:this.$refs.list.InvoiceTypeName,
        PayId:this.$refs.list.PayId,
        PayName:this.$refs.list.PayName,
        BusinessTypeId:this.$refs.list.BusinessTypeId
      };
      this.$emit("select-multiple", data);
      this.$refs.list.clearSubSelectList()
      this.close();
    },
    treeSelect(data) {
      this.$refs.list.getData({ ...this.params, IdChain: data.IdChain });
    },
    titleClick() {
      this.$refs.list.getData({ ...this.params, IdChain: null });
    },
  },
};
</script>
